import React, { useState } from 'react'
import { Link } from 'react-router-dom'
import ModalVideo from 'react-modal-video'
import abimg from '../../images/background/pattern-1.png'
import abimg2 from '../../images/background/pattern-2.png'
import abimg3 from '../../images/background/pattern-3.png'
import abimg4 from '../../images/background/about-pattern.png'
import abimg5 from '../..//images/resource/about.jpg'
import { Roll } from "react-awesome-reveal";

const About = (props) => {

    const ClickHandler = () => {
        window.scrollTo(10, 0);
    }

    const [isOpen, setOpen] = useState(false)

    return (
        <section className="about-one" id="about">
            <div className="about-one_pattern-one" style={{ backgroundImage: `url(${abimg})` }}></div>
            <div className="about-one_pattern-two" style={{ backgroundImage: `url(${abimg3})` }}></div>
            <div className="about-one_pattern-three" style={{ backgroundImage: `url(${abimg2})` }}></div>
            <div className="auto-container">
                <div className="row clearfix">
                    <div className="about-one_image-column col-lg-6 col-md-12 col-sm-12">
                        <div className="about-one_image-inner">
                            <div className="about-one_pattern-four" style={{ backgroundImage: `url(${abimg4})` }}></div>
                            <Roll left triggerOnce={'false'}>
                                <div className="about-one_image">
                                    <img src={abimg5} alt="" />
                                </div>
                            </Roll>
                            {/* <button onClick={() => setOpen(true)} className="lightbox-video slider-one_play"><span className="fa fa-play"><i className="ripple"></i></span></button> */}
                        </div>
                    </div>
                    <div className="about-one_content-column col-lg-6 col-md-12 col-sm-12">
                        <div className="about-one_content-inner">
                            <div className="sec-title title-anim">
                                <div className="sec-title_title">Why The Lush Minds?</div>
                                <h2 className="sec-title_heading">More Than a Community, We're a Movement</h2>
                            </div>
                            <div className="about-one_bold-text">In today’s fast-paced work culture, we often chase deadlines but forget to nurture what truly fuels success, human connection, continuous growth, and mental well-being. That’s where The Lush Minds comes in.</div>
                            <div className="about-one_text">We are a growing collective of professionals, creators, learners, and leaders who believe that thriving at work means more than just ticking tasks. It means showing up as your full self, confident, connected, and clear-headed.</div>
                            {/* <div className="row clearfix">
                                <div className="about-one_block col-lg-6 col-md-6 col-sm-12">
                                    <div className="about-one_block-inner">
                                        <span className="about-one_block-icon flaticon-map"></span>
                                        <strong>Where</strong>
                                        North Harond, Canada
                                    </div>
                                </div>
                                <div className="about-one_block col-lg-6 col-md-6 col-sm-12">
                                    <div className="about-one_block-inner">
                                        <span className="about-one_block-icon flaticon-calendar-2"></span>
                                        <strong>When</strong>
                                        March 25 to 29, 2024
                                    </div>
                                </div>
                            </div> */}
                            {/* <div className="about-one_button">
                                <Link to="/register" onClick={ClickHandler} className="theme-btn btn-style-one">
                                    <span className="btn-wrap">
                                        <span className="text-one">Claim Your Invite</span>
                                        <span className="text-two">Claim Your Invite</span>
                                    </span>
                                </Link>
                            </div> */}
                        </div>
                    </div>
                </div>
            </div>
            <ModalVideo channel='youtube' autoplay isOpen={isOpen} videoId="cR_D3vBhh6U" onClose={() => setOpen(false)} />
        </section>
    )
}

export default About;